<mat-chip-set>
  <mat-chip
    *ngFor="let skill of skills"
    class="skill-chip"
  >{{ skill }}</mat-chip>
</mat-chip-set>
